import React from "react";
import MENU_LINKS from '../../../config/menuLinks'
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom';
import clsx from "clsx";
import URLS from "../../../config/navigation";
import AccountSettings from "../../../components/Profile/AccountSettings";
import EditProfile from "../../../components/Profile/EditProfile";
import SettingsMobileContainer from "../../../components/Common/SettingsMobileContainer";
import {ReactComponent as Arrow} from '../../../assets/img/arrowBack.svg'
const SettingsContainer = () => {
 
  const history = useHistory();
  const location = useLocation();
  console.log('MENU_LINKS',MENU_LINKS)
  console.log('location',location)
  let  pageTitle = "";
  if(location.pathname ===MENU_LINKS[0].url)
  {
       pageTitle = MENU_LINKS[0].name;
  }
  if(location.pathname ===MENU_LINKS[1].url)
  {
    pageTitle = MENU_LINKS[1].name;
  }
  return (
    <>
    {pageTitle !=="" &&
    <div className="mobileHeader">
      <Arrow onClick={e=>history.push(URLS.SETTINGS.SETTINGS_MOBILE)}></Arrow>
      <h2 className="H2"> {pageTitle}</h2>
    </div>
}
    <div className={"editProfileContainer"}>
      {
        location.pathname !== URLS.SETTINGS.SETTINGS_MOBILE &&
        (<div className={"sidebar"}>
          {
            MENU_LINKS.map((link, index) => (
              <span
                key={index}
                className={location.pathname === link.url ? clsx("link EMPHASIS_LARGE", "active") : "link EMPHASIS_LARGE"}
                onClick={() => history.push(link.url)}
              >
                  {link.name}
                </span>
            ))
          }
        </div>)
      }
      <Switch>
        <Route path={URLS.SETTINGS.EDIT} component={EditProfile} />
        <Route path={URLS.SETTINGS.SETTINGS} component={AccountSettings} />
        <Route path={URLS.PROFILE.SETTINGS_MOBILE} component={SettingsMobileContainer} />
        <Route component={() => <Redirect to={URLS.SETTINGS.EDIT} />} />
      </Switch>
    </div>
    </>
  );
}

export default SettingsContainer;
